import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { auth } from './backend/firebase'

import Header from './components/Header/Header'
import Home from './pages/Home/Home'
import Login from './pages/Login/Login'
import Checkout from './pages/Checkout/Checkout'

import { useStateValue } from './components/HOC/StateProvider'
import { DispatchTypes } from './store/reducer'

const { SET_USER } = DispatchTypes

function App() {
  const { state, dispatch } = useStateValue()

  useEffect(() => {
    // will only run once when the app component loads...
    auth.onAuthStateChanged((authUser) => {
      // console.log('THE USER IS >>> ', authUser)
      if (authUser) dispatch({ type: SET_USER, user: authUser })
      else dispatch({ type: SET_USER, user: null })
    })
  }, [])

  return (
    <div className='app'>
      <ToastContainer position='bottom-right' />
      <Router>
        <Switch>
          <Route path='/login'>
            <Login />
          </Route>
          <Route path='/checkout'>
            <Header />
            <Checkout />
          </Route>
          <Route path='/'>
            <Header />
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export default App
